import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

/** Inject Preview Token into the request */
@Injectable()
export class CraftPreviewInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID)
    private platformId: Object
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('/api/') && isPlatformBrowser(this.platformId)) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('x-craft-live-preview') && urlParams.has('token')) {
        const duplicate = req.clone({
          headers: new HttpHeaders({
            Accept: 'application/json',
            'x-craft-live-preview': urlParams.get('x-craft-live-preview') || '',
            'x-craft-token': urlParams.get('token') || '',
          }),
        });
        return next.handle(duplicate);
      } else {
        return next.handle(req);
      }
    } else {
      return next.handle(req);
    }
  }
}
